import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const CoverCropCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/CoverCropEditor')
  const { t: cropT } = useTranslation('@cibo/ui/cropNames')
  const detail = params.row.findDetail({ traitId, year })
  const input = detail?.input

  if (input?.crop) {
    return (
      <Stack flex={1} justifyContent="center">
        <Typography variant="body1">{cropT(input.crop)}</Typography>
        {!!input.plantedAt && !!input.terminatedAt && (
          <Typography variant="body2" color="text.secondary">
            {t('dates', {
              plant: new Date(input.plantedAt),
              harvest: new Date(input.terminatedAt),
            })}
          </Typography>
        )}
      </Stack>
    )
  }

  return (
    <Stack flex={1} overflow="hidden">
      <Typography>{detail?.result ? t('yes') : t('no')}</Typography>
    </Stack>
  )
}
